import { Collapse } from "@mui/material";
import { ReactComponent as ArrowDownSmallIcon } from "assets/icon/arrowDownSmall.svg";
import { ReactComponent as ArrowUpSmallIcon } from "assets/icon/arrowUpSmall.svg";
import IconButton from "components/Button/IconButton";
import Label from "components/LabelInput/Label";
import { useResetSearchParams } from "hooks/common/useResetSearchParams";
import { globalAlertOn } from "modules/actions/Alert";
import { globalModalOff, globalModalOn } from "modules/actions/Modal";
import SearchAssignMember from "pages/CommonModal/Search/Assign/SearchAssignMember";
import SearchMember from "pages/CommonModal/Search/SearchMember";
import SearchSubject from "pages/ERP/MemberService/AssignChangeBranch/Modals/SearchSubject";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import mainIcon from "../../../src/assets/main_icon.png";
import "./Navbar.css";
import { LogoButton, TopButtonList, TopNavButton } from "./menuBarStyles";
// Firebase
import { simpleAlert } from "components/CommonLib/CommonLib";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

const navStyle = {
  height: "3.75rem",
  backgroundColor: process.env.REACT_APP_ENVIRONMENT === "develop" ? "#7533ED" : "#10134F",
  display: "inline-block",
  width: "100%",
  zIndex: 20,
  position: "fixed",
  left: 0,
  top: 0,
};

const Navbar = ({ permissionState }) => {
  const storesDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [showNotice, setShowNotice] = useState(false);
  const [notice, setNotice] = useState({ title: "", content: "", isRestricted: false });
  // 전역 상태 관리
  const { initAllSearchParams } = useResetSearchParams();

  const [permissionMenu, setPermissionMenu] = useState(permissionState.nav_menu);
  const [welcomeText, setWelcomeText] = useState("");
  const [open, setOpen] = useState(false);

  const goToMemberView = (retData) => {
    storesDispatch(globalModalOff());
    navigate("/member_info/" + retData.member_info.member_id);
  };

  const openSearchMemberModal = () => {
    const param = {
      goToMemberView: goToMemberView,
      mode: "search",
    };
    storesDispatch(
      globalModalOn({
        show: true,
        title: "회원검색",

        Content: <SearchMember modalParam={param} onModalDone={() => {}} />,
      }),
    );
  };

  const popAssignBranchChangeModal = () => {
    const param = {};
    storesDispatch(
      globalModalOn({
        show: true,
        title: "양도/지점변경",
        Content: <SearchAssignMember modalParam={param} onModalDone={onAssignModalDone} />,
      }),
    );
  };

  //1. 양도/지변 검색 모달 DONE
  const onAssignModalDone = (mode, data) => {
    if (mode === "change_branch") {
      //지점변경
      storesDispatch(globalModalOff());
      navigate("/change_branch", { state: data });
    } else {
      //양도
      const param = {
        assigner: data,
      };
      storesDispatch(globalModalOff());
      storesDispatch(
        globalModalOn({
          show: true,
          title: "양수자 검색",
          Content: <SearchSubject modalParam={param} onModalDone={onAssigneeModalDone} />,
        }),
      );
    }
  };
  //2. 양수검색 모달 DONE
  const onAssigneeModalDone = (data) => {
    //다음 버튼 -> 양도 페이지로 이동
    //양수자 신규등록 -> 등록 -> 양도페이지 이동
    storesDispatch(globalModalOff());
    navigate("/assign", { state: data });
  };

  const onClickSettings = () => {
    setOpen(!open);
  };

  //로그아웃 - 쿠키제거
  const remove_cookie = () => {
    const cookies = document.cookie.split("; ");
    const expiration = "Sat, 01 Jan 1972 00:00:00 GMT";
    for (let i = 0; i < cookies.length; i++) {
      document.cookie = cookies[i].split("=")[0] + "=; expires=" + expiration;
    }
    // 모든 저장된 검색 조건 초기화
    initAllSearchParams();
    navigate("/login");
  };

  const onClickLogout = () => {
    storesDispatch(
      globalAlertOn({
        show: true,
        titleText: "알림",
        bodyText: <Label labelText="로그아웃 하시겠습니까?" />,
        // width: "50rem",
        onBtnYes: () => {
          remove_cookie();
        },
        onBtnNo: () => {},
      }),
    );
  };

  // 오늘 하루 보지 않기 체크 여부 확인
  const checkDontShowToday = () => {
    const savedDate = localStorage.getItem(`dontShowToday`);
    const today = new Date().toISOString().split("T")[0];

    return savedDate === today;
  };

  useEffect(() => {
    setOpen(false);
  }, [location]);

  useEffect(() => {
    if (permissionState.staff_name) {
      setWelcomeText(
        permissionState.staff_name + "(" + permissionState.auth_id + ") 님 환영합니다.",
      );
    } else {
      setWelcomeText("환영합니다.");
    }
    setPermissionMenu(permissionState.nav_menu);
  }, [permissionState]);

  // 공지사항 조회
  useEffect(() => {
    const noticeDocRef = doc(db, "deploy", "notice");

    const unsubscribe = onSnapshot(
      noticeDocRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const { isVisible, content, title, isRestricted } = docSnapshot.data();
          setShowNotice(isVisible);
          setNotice({ title, content, isRestricted });
        } else {
          console.log("notice 문서가 없습니다.");
        }
      },
      (err) => {
        console.log("공지 에러:", err.code, err.message);
      },
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (showNotice) {
      if (notice.isRestricted) {
        // 사용 제한 공지사항
        simpleAlert(
          storesDispatch,
          notice.title,
          notice.content,
          true,
          () => {
            navigate("/login");
          },
          undefined,
          undefined,
        );
      } else if (!checkDontShowToday()) {
        // 오늘 하루 보지 않기 체크 안되어있을 때
        simpleAlert(
          storesDispatch,
          notice.title,
          notice.content,
          true,
          () => {},
          undefined,
          undefined,
          true,
        );
      }
    }
  }, [showNotice, notice.isRestricted]);

  return (
    <nav style={navStyle}>
      <div className="nav-contents">
        {/* 로고 */}
        <div>
          <LogoButton
            onClick={() => {
              navigate("/");
            }}
          >
            <img className="nav-logo" alt="iPhone_01" src={mainIcon} />
          </LogoButton>
        </div>
        <div className="nav-button-group">
          {permissionMenu.assign_menu.menu_active ? (
            <TopNavButton onClick={() => popAssignBranchChangeModal()}>
              {permissionMenu.assign_menu.menu_title}
            </TopNavButton>
          ) : null}
          {/* 신규등록 */}
          {permissionMenu.register_menu.menu_active ? (
            <TopNavButton as={Link} to={permissionMenu.register_menu.menu_url}>
              {permissionMenu.register_menu.menu_title}
            </TopNavButton>
          ) : null}
          {permissionMenu.search_menu.menu_active ? (
            <TopNavButton onClick={() => openSearchMemberModal()}>
              {permissionMenu.search_menu.menu_title}
            </TopNavButton>
          ) : null}

          {permissionMenu.setting_menu.menu_active ? (
            <div key={permissionMenu.setting_menu.menu_title}>
              {/* 설정 메뉴 */}
              <TopNavButton onClick={onClickSettings}>
                {permissionMenu.setting_menu.menu_title}
                {open ? (
                  <span style={{ marginLeft: "0.5rem", marginBottom: "0.3rem" }}>
                    <ArrowUpSmallIcon />
                  </span>
                ) : (
                  <span style={{ marginLeft: "0.5rem", marginBottom: "0.3rem" }}>
                    <ArrowDownSmallIcon />
                  </span>
                )}
              </TopNavButton>
              <Collapse in={open} timeout={100} unmountOnExit>
                {permissionMenu.setting_menu.children.map((item, idx) => (
                  <div key={idx}>
                    {item.menu_active ? (
                      <TopButtonList as={Link} to={item.menu_url}>
                        {item.menu_title}
                      </TopButtonList>
                    ) : (
                      <></>
                    )}
                  </div>
                ))}
              </Collapse>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          style={{ display: "flex", alignItems: "center", marginLeft: "auto", marginRight: "2rem" }}
        >
          <Label
            labelText={welcomeText}
            color="white"
            marginRight="1rem"
            minWidth="fit-content"
            whiteSpace="nowrap"
          />
          <IconButton type="logout" onClick={onClickLogout} />
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
